// Holds back third-party embeds (Elfsight YouTube gallery, Facebook feed, ...) until the
// visitor gives marketing consent in the cookie banner, or clicks "Inhalt laden".
// The embed's real class sits in data-consent-class (see sections/dynamic-html.liquid);
// load() turns the placeholder back into a real widget for the Elfsight script to pick up.
(() => {
  const embeds = [...document.querySelectorAll('[data-consent-class]')];
  if (!embeds.length) return;

  const privacyUrl = window.Shopify && window.Shopify.routes
    ? `${window.Shopify.routes.root}policies/privacy-policy`
    : '/policies/privacy-policy';

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // Elfsight only notices newly inserted widgets, so swap in a fresh element rather
  // than adding the class to the placeholder.
  const insertWidget = (el, className) => {
    const widget = document.createElement('div');
    widget.className = className;
    [...el.attributes].forEach(({ name, value }) => {
      if (!['class', 'data-consent-class', 'data-consent-provider'].includes(name)) widget.setAttribute(name, value);
    });
    el.replaceWith(widget);
    return widget;
  };

  // A widget inserted while Elfsight is still booting another one can stay empty, so
  // re-insert it if it hasn't rendered after a few seconds.
  const load = async (el) => {
    if (!el.isConnected || !el.hasAttribute('data-consent-class')) return;
    const className = el.getAttribute('data-consent-class');
    let widget = insertWidget(el, className);
    for (let attempt = 0; attempt < 3; attempt++) {
      for (let waited = 0; waited < 4000 && !widget.children.length; waited += 250) {
        await wait(250);
      }
      if (widget.children.length || !widget.isConnected) return;
      widget = insertWidget(widget, className);
    }
  };

  // One widget at a time: inserting several at once makes Elfsight boot twice and the
  // YouTube gallery never renders.
  let queue = Promise.resolve();
  const loadAll = () => {
    embeds.forEach((el) => {
      queue = queue.then(() => load(el));
    });
  };

  const marketingConsented = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return false;
    const consent = privacy.currentVisitorConsent() || {};
    return consent.marketing === 'yes';
  };

  embeds.forEach((el) => {
    const provider = el.getAttribute('data-consent-provider') || 'einem externen Anbieter (z. B. YouTube oder Facebook)';
    el.classList.add('consent-embed');
    el.innerHTML = `
      <div class="consent-embed__placeholder">
        <p>Hier wird ein Inhalt von ${provider} angezeigt. Beim Laden werden Daten an den Anbieter übertragen und Cookies gesetzt. <a href="${privacyUrl}">Datenschutz</a></p>
        <button type="button" class="button-primary consent-embed__button">Inhalt laden</button>
      </div>
    `;
    el.querySelector('.consent-embed__button').addEventListener('click', () => {
      queue = queue.then(() => load(el));
    });
  });

  // Pandectes passes the banner choice to Shopify's Customer Privacy API, which fires
  // visitorConsentCollected when it changes.
  document.addEventListener('visitorConsentCollected', (event) => {
    if (event.detail && event.detail.marketingAllowed) loadAll();
  });

  // Returning visitors who already accepted: the privacy API loads asynchronously, so
  // check for a few seconds until it is available.
  let tries = 0;
  const check = () => {
    if (marketingConsented()) {
      loadAll();
      return;
    }
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if ((!privacy || typeof privacy.currentVisitorConsent !== 'function') && tries++ < 20) {
      setTimeout(check, 500);
    }
  };
  check();
})();
